import { cloneDeep } from "base/utils";

import { EVENT_TYPES, CHANNEL_CONST } from "../utils/constant";
import { CommentService } from "../service/comment.service";

async function commentLiveSync(storeData, response) {
  switch (response.EventType) {
    case EVENT_TYPES.NEW_COMMENT: {
      let postObj = storeData.postMapping[response.PostId];
      if (
        !postObj ||
        (postObj &&
          !postObj.comments.find(
            (comment) => comment._id === response.CommentId
          ))
      ) {
        let newStoreData = cloneDeep(storeData);
        let [getCommentDetails] = CommentService.getComment({
          teamId: response.teamId,
          medium: CHANNEL_CONST.CHANNEL,
          mediumId: response.MediumId,
          instanceType: CHANNEL_CONST.POST,
          instanceId: response.PostId,
          commentId: response.CommentId
        });
        return await getCommentDetails().then((result) => {
          newStoreData.postMapping[response.PostId] = {
            ...newStoreData.postMapping[response.PostId]
          };
          if (newStoreData.postMapping[response.PostId]) {
            newStoreData.postMapping[response.PostId].comments.push({
              ...result.Comment,
              fromLiveSync: true
            });
          } else {
            newStoreData.postMapping[response.PostId] = {
              comments: [{ ...result.Comment, fromLiveSync: true }],
              reactions: [],
              totalComments: 1,
              showAllComments: true,
              fromNotification: false,
              noCommentFound: false
            };
          }
          newStoreData.commentReactionMapping[result.Comment._id] =
            result.Comment.Reactions;
          return { newState: newStoreData };
        });
      }
      return { newState: null };
    }
    case EVENT_TYPES.EDIT_COMMENT: {
      const comment = storeData.postMapping[response.PostId]?.comments.find(
        (comment) => comment._id === response.CommentId
      );
      if (comment && comment._modified_at !== response._modified_at) {
        const [getCommentPromise] = CommentService.getComment({
          teamId: response.teamId,
          medium: CHANNEL_CONST.CHANNEL,
          mediumId: response.MediumId,
          instanceType: CHANNEL_CONST.POST,
          instanceId: response.PostId,
          commentId: response.CommentId
        });
        return await getCommentPromise().then((result) => {
          let commentIndex = storeData.postMapping[
            response.PostId
          ].comments.findIndex((comment) => comment._id === response.CommentId);
          let newStoreData = cloneDeep(storeData);
          newStoreData.postMapping[response.PostId].comments[commentIndex] = {
            ...result.Comment,
            fromLiveSync: true
          };
          return { newState: newStoreData };
        });
      }
      return { newState: null };
    }
    case EVENT_TYPES.DELETE_COMMENT: {
      let postObj = storeData.postMapping[response.PostId];
      if (
        postObj &&
        postObj.comments.find((comment) => comment._id === response.CommentId)
      ) {
        let commentIndex = postObj.comments.findIndex(
          (comment) => comment._id === response.CommentId
        );
        let newStoreData = cloneDeep(storeData);
        newStoreData.postMapping[response.PostId].comments[
          commentIndex
        ].isDeleted = true;
        return { newState: newStoreData };
      }
      return { newState: null };
    }
    case EVENT_TYPES.NEW_REPLY: {
      let postObj = storeData.postMapping[response.PostId];
      let commentObj = storeData.commentReplyMapping[response.CommentId];
      if (
        postObj &&
        postObj.comments.find(
          (comment) => comment._id === response.CommentId
        ) &&
        (!commentObj ||
          (commentObj &&
            commentObj?.findIndex((reply) => reply._id === response.replyId) ===
              -1))
      ) {
        const [getReplyPromise] = CommentService.getReply({
          teamId: response.teamId,
          medium: CHANNEL_CONST.CHANNEL,
          mediumId: response.MediumId,
          instanceType: CHANNEL_CONST.POST,
          instanceId: response.PostId,
          commentId: response.CommentId,
          replyId: response.ReplyId
        });
        return await getReplyPromise().then((result) => {
          let newStoreData = cloneDeep(storeData);
          if (newStoreData.commentReplyMapping[response.CommentId]) {
            newStoreData.commentReplyMapping[response.CommentId].push({
              ...result,
              fromLiveSync: true
            });
            newStoreData.replyReactionMapping[result._id] = result.Reactions;
          } else {
            let commentIndex = newStoreData.postMapping[
              response.PostId
            ].comments.findIndex(
              (comment) => comment._id === response.CommentId
            );
            newStoreData.postMapping[response.PostId].comments[
              commentIndex
            ].TotalReplies += 1;
          }
          return { newState: newStoreData };
        });
      }
      return { newState: null };
    }
    case EVENT_TYPES.EDIT_REPLY: {
      const comment = storeData.postMapping[response.PostId]?.comments.find(
        (comment) => comment._id === response.CommentId
      );
      const reply = storeData.commentReplyMapping[response.CommentId]?.find(
        (reply) => reply._id === response.ReplyId
      );
      if (comment && reply && reply._modified_at !== response._modified_at) {
        const [getReplyPromise] = CommentService.getReply({
          teamId: response.teamId,
          medium: CHANNEL_CONST.CHANNEL,
          mediumId: response.MediumId,
          instanceType: CHANNEL_CONST.POST,
          instanceId: response.PostId,
          commentId: response.CommentId,
          replyId: response.ReplyId
        });
        return await getReplyPromise().then((result) => {
          let newStoreData = cloneDeep(storeData);
          let replyIndex = newStoreData.commentReplyMapping[
            response.CommentId
          ].findIndex((reply) => reply._id === result._id);
          newStoreData.commentReplyMapping[response.CommentId][replyIndex] = {
            ...result,
            fromLiveSync: true
          };
          return { newState: newStoreData };
        });
      }
      return { newState: null };
    }
    case EVENT_TYPES.DELETE_REPLY: {
      if (
        storeData.postMapping[response.PostId] &&
        storeData.postMapping[response.PostId].comments.find(
          (comment) => comment._id === response.CommentId
        )
      ) {
        let newStoreData = cloneDeep(storeData);
        if (newStoreData.commentReplyMapping[response.CommentId]) {
          let replyIndex = newStoreData.commentReplyMapping[
            response.CommentId
          ].findIndex((reply) => reply._id === response.ReplyId);
          newStoreData.commentReplyMapping[response.CommentId][
            replyIndex
          ].isDeleted = true;
        }
        let commentIndex = newStoreData.postMapping[
          response.PostId
        ].comments.findIndex((comment) => comment._id === response.CommentId);
        newStoreData.postMapping[response.PostId].comments[
          commentIndex
        ].TotalReplies -= 1;
        return { newState: newStoreData };
      }
      return { newState: null };
    }
    case EVENT_TYPES.NEW_POST_REACTION: {
      let newStoreData = cloneDeep(storeData);
      if (newStoreData.postMapping[response.PostId]) {
        const existingReactedUser = newStoreData.postMapping[
          response.PostId
        ].reactions?.find(
          (reactedUser) => reactedUser._id === response.ReactedUser._id
        );
        if (
          existingReactedUser &&
          existingReactedUser.ReactionType !== response.ReactedUser.ReactionType
        ) {
          let reactedUser = newStoreData.postMapping[
            response.PostId
          ].reactions.find((user) => user._id === response.ReactedUser._id);
          reactedUser["ReactionType"] = response.ReactedUser.ReactionType;
        } else if (!existingReactedUser) {
          newStoreData.postMapping[response.PostId].reactions.push(
            response.ReactedUser
          );
        }
        return { newState: newStoreData };
      } else {
        newStoreData.postMapping[response.PostId] = {
          comments: [],
          reactions: [response.ReactedUser]
        };
        return { newState: newStoreData };
      }
    }
    case EVENT_TYPES.DELETE_POST_REACTION: {
      if (storeData.postMapping[response.PostId]) {
        let newStoreData = cloneDeep(storeData);
        const existingReactedUser = newStoreData.postMapping[
          response.PostId
        ].reactions?.find(
          (reactedUser) => reactedUser._id === response.ReactedUserId
        );
        if (existingReactedUser) {
          newStoreData.postMapping[response.PostId].reactions =
            newStoreData.postMapping[response.PostId].reactions.filter(
              (user) => user._id !== response.ReactedUserId
            );
        }
        return { newState: newStoreData };
      }
      return { newState: null };
    }
    case EVENT_TYPES.NEW_COMMENT_REACTION: {
      if (
        storeData.postMapping[response.PostId] &&
        storeData.postMapping[response.PostId].comments.find(
          (comment) => comment._id === response.CommentId
        )
      ) {
        let newStoreData = cloneDeep(storeData);
        const existingReactedUser = newStoreData.commentReactionMapping[
          response.CommentId
        ]?.find((reactedUser) => reactedUser._id === response.ReactedUser._id);
        if (
          existingReactedUser &&
          existingReactedUser.ReactionType !== response.ReactedUser.ReactionType
        ) {
          let reactedUser = newStoreData.commentReactionMapping[
            response.CommentId
          ].find((user) => user._id === response.ReactedUser._id);
          reactedUser["ReactionType"] = response.ReactedUser.ReactionType;
        } else if (!existingReactedUser) {
          newStoreData.commentReactionMapping[response.CommentId].push({
            Name: response.ReactedUser.Name,
            ReactionType: response.ReactedUser.ReactionType,
            _id: response.ReactedUser._id
          });
        }
        return { newState: newStoreData };
      }
      return { newState: null };
    }
    case EVENT_TYPES.DELETE_COMMENT_REACTION: {
      if (
        storeData.postMapping[response.PostId] &&
        storeData.postMapping[response.PostId].comments.find(
          (comment) => comment._id === response.CommentId
        )
      ) {
        let newStoreData = cloneDeep(storeData);
        const existingReactedUser = newStoreData.commentReactionMapping[
          response.CommentId
        ]?.find((reactedUser) => reactedUser._id === response.ReactedUserId);
        if (existingReactedUser) {
          newStoreData.commentReactionMapping[response.CommentId] =
            newStoreData.commentReactionMapping[response.CommentId].filter(
              (user) => user._id !== response.ReactedUserId
            );
        }
        return { newState: newStoreData };
      }
      return { newState: null };
    }
    case EVENT_TYPES.NEW_REPLY_REACTION: {
      if (
        storeData.postMapping[response.PostId] &&
        storeData.postMapping[response.PostId].comments.find(
          (comment) => comment._id === response.CommentId
        ) &&
        storeData.commentReplyMapping[response.CommentId]
      ) {
        let newStoreData = cloneDeep(storeData);
        const existingReactedUser = newStoreData.replyReactionMapping[
          response.ReplyId
        ]?.find((reactedUser) => reactedUser._id === response.ReactedUser._id);
        if (
          existingReactedUser &&
          existingReactedUser.ReactionType !== response.ReactedUser.ReactionType
        ) {
          let reactedUser = newStoreData.replyReactionMapping[
            response.ReplyId
          ].find((user) => user._id === response.ReactedUser._id);
          reactedUser["ReactionType"] = response.ReactedUser.ReactionType;
        } else if (!existingReactedUser) {
          newStoreData.replyReactionMapping[response.ReplyId].push({
            Name: response.ReactedUser.Name,
            ReactionType: response.ReactedUser.ReactionType,
            _id: response.ReactedUser._id
          });
        }
        return { newState: newStoreData };
      }
      return { newState: null };
    }
    case EVENT_TYPES.DELETE_REPLY_REACTION: {
      if (
        storeData.postMapping[response.PostId] &&
        storeData.postMapping[response.PostId].comments.find(
          (comment) => comment._id === response.CommentId
        ) &&
        storeData.commentReplyMapping[response.CommentId]
      ) {
        let newStoreData = cloneDeep(storeData);
        const existingReactedUser = newStoreData.replyReactionMapping[
          response.ReplyId
        ]?.find((reactedUser) => reactedUser._id === response.ReactedUserId);
        if (existingReactedUser) {
          newStoreData.replyReactionMapping[response.ReplyId] =
            newStoreData.replyReactionMapping[response.ReplyId].filter(
              (user) => user._id !== response.ReactedUserId
            );
        }
        return { newState: newStoreData };
      }
      return { newState: null };
    }
    default:
      return { newState: null };
  }
}

export { commentLiveSync };
